export enum ReportColumnPinType {
    none = 0,
    left = 1,
    right = 2
}
